import type { LegacyRef, MutableRefObject, RefCallback } from 'react';

import { getStaticPrefix } from '@eneco/common/env';

import { Fonts, FontFace } from '../types';

export const getFontFaces = (fonts: Fonts, prefix?: string): Partial<FontFace>[] =>
  fonts.map(([fontFamily, fontWeight, fileName, format]) => ({
    fontFamily,
    fontWeight,
    fontStyle: 'normal',
    fontDisplay: 'swap',
    src: `url('${(prefix ?? getStaticPrefix()).replace(/\/$/, '')}/font/${fileName}') format('${format}')`,
  }));

// Borrowed from https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeRefs<T = any>(refs: Array<MutableRefObject<T> | LegacyRef<T>>): RefCallback<T> {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    });
  };
}
